import { createApp } from "vue";
import App from "./App.vue";
import store from "../infrastructure/repository/store/store";
import router from "./routes";
import "../infrastructure/presentation/assets/css/reset.css";
import "../infrastructure/presentation/assets/css/base.css";

if (process.env.VUE_APP_THEME == "circulo") {
  /** Set title of the page. */
  document.title = "Ganhe Mais | Círculo";
  require("../infrastructure/presentation/assets/css/template-circulo.css");
}
if (process.env.VUE_APP_THEME == "default") {
  /** Set title of the page. */
  document.title = "Decola | Educação Corporativa";

  require("../infrastructure/presentation/assets/css/template-default.css");
}
if (process.env.VUE_APP_THEME == "construcolor") {
  /** Set title of the page. */
  document.title = "Decola - Construcolor | Educação Corporativa";

  require("../infrastructure/presentation/assets/css/template-construcolor.css");
}
if (process.env.VUE_APP_THEME == "gtop") {
  /** Set title of the page. */
  document.title = "Portal GTop";

  require("../infrastructure/presentation/assets/css/template-gtop.css");
}

const app = createApp(App)
  .use(router)
  .use(store);

app.directive("focus", {
  mounted: el => {
    el.focus();
  }
});

app.directive("view-scroll", {
  mounted(el) {
    el.addEventListener("scroll", () => {
      if (el.scrollTop) {
        document.querySelector("[data-main-header]")?.classList.add("overlap");
      } else {
        document
          .querySelector("[data-main-header]")
          ?.classList.remove("overlap");
      }
    });
  }
});

app.directive("scroll-button", {
  mounted(el) {
    window.addEventListener("resize", () => {
      if (el.scrollWidth > document.body.scrollWidth) {
        el.classList.add("scroll");
      } else {
        el.classList.remove("scroll");
      }
    });
  },

  beforeMount(el) {
    if (el.scrollWidth > document.body.scrollWidth) {
      el.classList.add("scroll");
    }
  }
});

/** Set meta description for SEO of the website. */
const metaDescription: HTMLMetaElement = document.createElement("meta");
metaDescription.name = "description";
metaDescription.content =
  "O Decola surgiu para levar informação e conhecimento para os colaboradores do Grupo Lince, seus familiares e toda a comunidade. Com o propósito de ser referência na aprendizagem dos colaboradores e da comunidade local.";
if (process.env.VUE_APP_THEME === "construcolor") {
  metaDescription.content =
    "O Decola surgiu para levar informação e conhecimento para os colaboradores do Grupo Lince, seus familiares e toda a comunidade. Com o propósito de ser referência na aprendizagem dos colaboradores e da comunidade local.";
}
document.head.appendChild(metaDescription);

/** Returns the key of the PDF reader. */
export const pdfKey = () => {
  let key: string = "a932842a8afd4e18b7a1470ff065dbb7";

  if (
    process.env.NODE_ENV === "production" &&
    window.location.origin === "https://decolahomolog.lince.com.br"
  ) {
    key = "c144b9a3ec1c4781b8dc516cb31c0dda";
  }

  if (process.env.VUE_APP_THEME === "construcolor") {
    key = "9c0bd8acdd27417f913596fc5e3f1b68";
  }

  if (process.env.VUE_APP_THEME === "gtop") {
    key = "54627fb3e6184b0ea6ed8bc671e8e93b";
  }

  return key;
};

app.mount("#app");
